/** Agent shell nav, stats, and page titles — non-English overrides */
export const panelAgentLayoutByLang = {
  es: {
    'agent.layout.sidebarTitle': 'MineMe Agente',
    'agent.layout.role': 'Cuenta de agente',
    'agent.layout.nav.dashboard': 'Panel',
    'agent.layout.nav.referrals': 'Referidos',
    'agent.layout.nav.commissions': 'Comisiones',
    'agent.layout.nav.team': 'Mi equipo',
    'agent.layout.nav.transactions': 'Transacciones',
    'agent.layout.nav.withdraw': 'Retiro',
    'agent.layout.nav.notifications': 'Notificaciones',
    'agent.layout.nav.settings': 'Ajustes',
    'agent.layout.withdrawalLogs': 'Historial de retiros',
    'agent.layout.stats.commission': 'Saldo de comisiones',
    'agent.layout.stats.direct': 'Referidos directos',
    'agent.layout.stats.earned': 'Total ganado',
    'agent.layout.workspace': 'Espacio de agente',
    'agent.layout.logout': 'Cerrar sesión',
    'agent.page.dashboard': 'Panel',
    'agent.page.referrals': 'Referidos',
    'agent.page.commissions': 'Comisiones',
    'agent.page.team': 'Mi equipo',
    'agent.page.transactions': 'Transacciones',
    'agent.page.withdraw': 'Retiro',
    'agent.page.withdrawLogs': 'Historial de retiros',
    'agent.page.settings': 'Ajustes',
    'agent.page.notifications': 'Notificaciones',
  },
  de: {
    'agent.layout.sidebarTitle': 'MineMe Agent',
    'agent.layout.role': 'Agentenkonto',
    'agent.layout.nav.dashboard': 'Dashboard',
    'agent.layout.nav.referrals': 'Empfehlungen',
    'agent.layout.nav.commissions': 'Provisionen',
    'agent.layout.nav.team': 'Mein Team',
    'agent.layout.nav.transactions': 'Transaktionen',
    'agent.layout.nav.withdraw': 'Auszahlung',
    'agent.layout.nav.notifications': 'Benachrichtigungen',
    'agent.layout.nav.settings': 'Einstellungen',
    'agent.layout.withdrawalLogs': 'Auszahlungsprotokoll',
    'agent.layout.stats.commission': 'Provisionsguthaben',
    'agent.layout.stats.direct': 'Direkte Empfehlungen',
    'agent.layout.stats.earned': 'Gesamt verdient',
    'agent.layout.workspace': 'Agenten-Arbeitsbereich',
    'agent.layout.logout': 'Abmelden',
    'agent.page.dashboard': 'Dashboard',
    'agent.page.referrals': 'Empfehlungen',
    'agent.page.commissions': 'Provisionen',
    'agent.page.team': 'Mein Team',
    'agent.page.transactions': 'Transaktionen',
    'agent.page.withdraw': 'Auszahlung',
    'agent.page.withdrawLogs': 'Auszahlungsprotokoll',
    'agent.page.settings': 'Einstellungen',
    'agent.page.notifications': 'Benachrichtigungen',
  },
  fr: {
    'agent.layout.sidebarTitle': 'MineMe Agent',
    'agent.layout.role': 'Compte agent',
    'agent.layout.nav.dashboard': 'Tableau de bord',
    'agent.layout.nav.referrals': 'Parrainages',
    'agent.layout.nav.commissions': 'Commissions',
    'agent.layout.nav.team': 'Mon équipe',
    'agent.layout.nav.transactions': 'Transactions',
    'agent.layout.nav.withdraw': 'Retrait',
    'agent.layout.nav.notifications': 'Notifications',
    'agent.layout.nav.settings': 'Paramètres',
    'agent.layout.withdrawalLogs': 'Historique des retraits',
    'agent.layout.stats.commission': 'Solde de commission',
    'agent.layout.stats.direct': 'Parrainages directs',
    'agent.layout.stats.earned': 'Total gagné',
    'agent.layout.workspace': 'Espace agent',
    'agent.layout.logout': 'Déconnexion',
    'agent.page.dashboard': 'Tableau de bord',
    'agent.page.referrals': 'Parrainages',
    'agent.page.commissions': 'Commissions',
    'agent.page.team': 'Mon équipe',
    'agent.page.transactions': 'Transactions',
    'agent.page.withdraw': 'Retrait',
    'agent.page.withdrawLogs': 'Historique des retraits',
    'agent.page.settings': 'Paramètres',
    'agent.page.notifications': 'Notifications',
  },
  ar: {
    'agent.layout.sidebarTitle': 'MineMe وكيل',
    'agent.layout.role': 'حساب الوكيل',
    'agent.layout.nav.dashboard': 'لوحة التحكم',
    'agent.layout.nav.referrals': 'الإحالات',
    'agent.layout.nav.commissions': 'العمولات',
    'agent.layout.nav.team': 'فريقي',
    'agent.layout.nav.transactions': 'المعاملات',
    'agent.layout.nav.withdraw': 'سحب',
    'agent.layout.nav.notifications': 'الإشعارات',
    'agent.layout.nav.settings': 'الإعدادات',
    'agent.layout.withdrawalLogs': 'سجل السحوبات',
    'agent.layout.stats.commission': 'رصيد العمولة',
    'agent.layout.stats.direct': 'إحالات مباشرة',
    'agent.layout.stats.earned': 'الإجمالي المكتسب',
    'agent.layout.workspace': 'مساحة الوكيل',
    'agent.layout.logout': 'تسجيل الخروج',
    'agent.page.dashboard': 'لوحة التحكم',
    'agent.page.referrals': 'الإحالات',
    'agent.page.commissions': 'العمولات',
    'agent.page.team': 'فريقي',
    'agent.page.transactions': 'المعاملات',
    'agent.page.withdraw': 'سحب',
    'agent.page.withdrawLogs': 'سجل السحوبات',
    'agent.page.settings': 'الإعدادات',
    'agent.page.notifications': 'الإشعارات',
  },
  ja: {
    'agent.layout.sidebarTitle': 'MineMe エージェント',
    'agent.layout.role': 'エージェントアカウント',
    'agent.layout.nav.dashboard': 'ダッシュボード',
    'agent.layout.nav.referrals': '紹介',
    'agent.layout.nav.commissions': 'コミッション',
    'agent.layout.nav.team': 'マイチーム',
    'agent.layout.nav.transactions': '取引',
    'agent.layout.nav.withdraw': '出金',
    'agent.layout.nav.notifications': '通知',
    'agent.layout.nav.settings': '設定',
    'agent.layout.withdrawalLogs': '出金履歴',
    'agent.layout.stats.commission': 'コミッション残高',
    'agent.layout.stats.direct': '直接紹介',
    'agent.layout.stats.earned': '累計獲得',
    'agent.layout.workspace': 'エージェントワークスペース',
    'agent.layout.logout': 'ログアウト',
    'agent.page.dashboard': 'ダッシュボード',
    'agent.page.referrals': '紹介',
    'agent.page.commissions': 'コミッション',
    'agent.page.team': 'マイチーム',
    'agent.page.transactions': '取引',
    'agent.page.withdraw': '出金',
    'agent.page.withdrawLogs': '出金履歴',
    'agent.page.settings': '設定',
    'agent.page.notifications': '通知',
  },
  ko: {
    'agent.layout.sidebarTitle': 'MineMe 에이전트',
    'agent.layout.role': '에이전트 계정',
    'agent.layout.nav.dashboard': '대시보드',
    'agent.layout.nav.referrals': '추천',
    'agent.layout.nav.commissions': '커미션',
    'agent.layout.nav.team': '내 팀',
    'agent.layout.nav.transactions': '거래',
    'agent.layout.nav.withdraw': '출금',
    'agent.layout.nav.notifications': '알림',
    'agent.layout.nav.settings': '설정',
    'agent.layout.withdrawalLogs': '출금 내역',
    'agent.layout.stats.commission': '커미션 잔액',
    'agent.layout.stats.direct': '직접 추천',
    'agent.layout.stats.earned': '총 수익',
    'agent.layout.workspace': '에이전트 워크스페이스',
    'agent.layout.logout': '로그아웃',
    'agent.page.dashboard': '대시보드',
    'agent.page.referrals': '추천',
    'agent.page.commissions': '커미션',
    'agent.page.team': '내 팀',
    'agent.page.transactions': '거래',
    'agent.page.withdraw': '출금',
    'agent.page.withdrawLogs': '출금 내역',
    'agent.page.settings': '설정',
    'agent.page.notifications': '알림',
  },
  'zh-CN': {
    'agent.layout.sidebarTitle': 'MineMe 代理',
    'agent.layout.role': '代理账户',
    'agent.layout.nav.dashboard': '仪表盘',
    'agent.layout.nav.referrals': '推荐',
    'agent.layout.nav.commissions': '佣金',
    'agent.layout.nav.team': '我的团队',
    'agent.layout.nav.transactions': '交易',
    'agent.layout.nav.withdraw': '提现',
    'agent.layout.nav.notifications': '通知',
    'agent.layout.nav.settings': '设置',
    'agent.layout.withdrawalLogs': '提现记录',
    'agent.layout.stats.commission': '佣金余额',
    'agent.layout.stats.direct': '直接推荐',
    'agent.layout.stats.earned': '累计收益',
    'agent.layout.workspace': '代理工作区',
    'agent.layout.logout': '退出登录',
    'agent.page.dashboard': '仪表盘',
    'agent.page.referrals': '推荐',
    'agent.page.commissions': '佣金',
    'agent.page.team': '我的团队',
    'agent.page.transactions': '交易',
    'agent.page.withdraw': '提现',
    'agent.page.withdrawLogs': '提现记录',
    'agent.page.settings': '设置',
    'agent.page.notifications': '通知',
  },
  pt: {
    'agent.layout.sidebarTitle': 'MineMe Agente',
    'agent.layout.role': 'Conta de agente',
    'agent.layout.nav.dashboard': 'Painel',
    'agent.layout.nav.referrals': 'Indicações',
    'agent.layout.nav.commissions': 'Comissões',
    'agent.layout.nav.team': 'Minha equipe',
    'agent.layout.nav.transactions': 'Transações',
    'agent.layout.nav.withdraw': 'Saque',
    'agent.layout.nav.notifications': 'Notificações',
    'agent.layout.nav.settings': 'Configurações',
    'agent.layout.withdrawalLogs': 'Histórico de saques',
    'agent.layout.stats.commission': 'Saldo de comissões',
    'agent.layout.stats.direct': 'Indicações diretas',
    'agent.layout.stats.earned': 'Total ganho',
    'agent.layout.workspace': 'Área do agente',
    'agent.layout.logout': 'Sair',
    'agent.page.dashboard': 'Painel',
    'agent.page.referrals': 'Indicações',
    'agent.page.commissions': 'Comissões',
    'agent.page.team': 'Minha equipe',
    'agent.page.transactions': 'Transações',
    'agent.page.withdraw': 'Saque',
    'agent.page.withdrawLogs': 'Histórico de saques',
    'agent.page.settings': 'Configurações',
    'agent.page.notifications': 'Notificações',
  },
  it: {
    'agent.layout.sidebarTitle': 'MineMe Agente',
    'agent.layout.role': 'Account agente',
    'agent.layout.nav.dashboard': 'Dashboard',
    'agent.layout.nav.referrals': 'Referral',
    'agent.layout.nav.commissions': 'Commissioni',
    'agent.layout.nav.team': 'Il mio team',
    'agent.layout.nav.transactions': 'Transazioni',
    'agent.layout.nav.withdraw': 'Prelievo',
    'agent.layout.nav.notifications': 'Notifiche',
    'agent.layout.nav.settings': 'Impostazioni',
    'agent.layout.withdrawalLogs': 'Cronologia prelievi',
    'agent.layout.stats.commission': 'Saldo commissioni',
    'agent.layout.stats.direct': 'Referral diretti',
    'agent.layout.stats.earned': 'Totale guadagnato',
    'agent.layout.workspace': 'Area agente',
    'agent.layout.logout': 'Esci',
    'agent.page.dashboard': 'Dashboard',
    'agent.page.referrals': 'Referral',
    'agent.page.commissions': 'Commissioni',
    'agent.page.team': 'Il mio team',
    'agent.page.transactions': 'Transazioni',
    'agent.page.withdraw': 'Prelievo',
    'agent.page.withdrawLogs': 'Cronologia prelievi',
    'agent.page.settings': 'Impostazioni',
    'agent.page.notifications': 'Notifiche',
  },
  ru: {
    'agent.layout.sidebarTitle': 'MineMe Агент',
    'agent.layout.role': 'Аккаунт агента',
    'agent.layout.nav.dashboard': 'Панель',
    'agent.layout.nav.referrals': 'Рефералы',
    'agent.layout.nav.commissions': 'Комиссии',
    'agent.layout.nav.team': 'Моя команда',
    'agent.layout.nav.transactions': 'Транзакции',
    'agent.layout.nav.withdraw': 'Вывод',
    'agent.layout.nav.notifications': 'Уведомления',
    'agent.layout.nav.settings': 'Настройки',
    'agent.layout.withdrawalLogs': 'История выводов',
    'agent.layout.stats.commission': 'Баланс комиссий',
    'agent.layout.stats.direct': 'Прямые рефералы',
    'agent.layout.stats.earned': 'Всего заработано',
    'agent.layout.workspace': 'Рабочая область агента',
    'agent.layout.logout': 'Выйти',
    'agent.page.dashboard': 'Панель',
    'agent.page.referrals': 'Рефералы',
    'agent.page.commissions': 'Комиссии',
    'agent.page.team': 'Моя команда',
    'agent.page.transactions': 'Транзакции',
    'agent.page.withdraw': 'Вывод',
    'agent.page.withdrawLogs': 'История выводов',
    'agent.page.settings': 'Настройки',
    'agent.page.notifications': 'Уведомления',
  },
  bn: {
    'agent.layout.sidebarTitle': 'MineMe এজেন্ট',
    'agent.layout.role': 'এজেন্ট অ্যাকাউন্ট',
    'agent.layout.nav.dashboard': 'ড্যাশবোর্ড',
    'agent.layout.nav.referrals': 'রেফারেল',
    'agent.layout.nav.commissions': 'কমিশন',
    'agent.layout.nav.team': 'আমার দল',
    'agent.layout.nav.transactions': 'লেনদেন',
    'agent.layout.nav.withdraw': 'উত্তোলন',
    'agent.layout.nav.notifications': 'বিজ্ঞপ্তি',
    'agent.layout.nav.settings': 'সেটিংস',
    'agent.layout.withdrawalLogs': 'উত্তোলনের ইতিহাস',
    'agent.layout.stats.commission': 'কমিশন ব্যালেন্স',
    'agent.layout.stats.direct': 'সরাসরি রেফারেল',
    'agent.layout.stats.earned': 'মোট আয়',
    'agent.layout.workspace': 'এজেন্ট ওয়ার্কস্পেস',
    'agent.layout.logout': 'লগ আউট',
    'agent.page.dashboard': 'ড্যাশবোর্ড',
    'agent.page.referrals': 'রেফারেল',
    'agent.page.commissions': 'কমিশন',
    'agent.page.team': 'আমার দল',
    'agent.page.transactions': 'লেনদেন',
    'agent.page.withdraw': 'উত্তোলন',
    'agent.page.withdrawLogs': 'উত্তোলনের ইতিহাস',
    'agent.page.settings': 'সেটিংস',
    'agent.page.notifications': 'বিজ্ঞপ্তি',
  },
  hi: {
    'agent.layout.sidebarTitle': 'MineMe एजेंट',
    'agent.layout.role': 'एजेंट खाता',
    'agent.layout.nav.dashboard': 'डैशबोर्ड',
    'agent.layout.nav.referrals': 'रेफ़रल',
    'agent.layout.nav.commissions': 'कमीशन',
    'agent.layout.nav.team': 'मेरी टीम',
    'agent.layout.nav.transactions': 'लेनदेन',
    'agent.layout.nav.withdraw': 'निकासी',
    'agent.layout.nav.notifications': 'सूचनाएँ',
    'agent.layout.nav.settings': 'सेटिंग्स',
    'agent.layout.withdrawalLogs': 'निकासी लॉग',
    'agent.layout.stats.commission': 'कमीशन शेष',
    'agent.layout.stats.direct': 'प्रत्यक्ष रेफ़रल',
    'agent.layout.stats.earned': 'कुल कमाई',
    'agent.layout.workspace': 'एजेंट वर्कस्पेस',
    'agent.layout.logout': 'लॉग आउट',
    'agent.page.dashboard': 'डैशबोर्ड',
    'agent.page.referrals': 'रेफ़रल',
    'agent.page.commissions': 'कमीशन',
    'agent.page.team': 'मेरी टीम',
    'agent.page.transactions': 'लेनदेन',
    'agent.page.withdraw': 'निकासी',
    'agent.page.withdrawLogs': 'निकासी लॉग',
    'agent.page.settings': 'सेटिंग्स',
    'agent.page.notifications': 'सूचनाएँ',
  },
};
